import { Link } from "react-router-dom";

function Footer() {
  const glossaryTerms = [
    { term: "Score Differential", path: "/formulas#score-differential" },
    { term: "Slope Rating", path: "/formulas#slope-rating" },
    { term: "Handicap Index Conversion", path: "/formulas#index-conversion" },
    { term: "Course Rating", path: "/formulas#course-rating" },
    { term: "GHIN Handicap Formula", path: "/formulas#ghin-formula" },
  ];

  return (
    <footer className="bg-[#1F2937] text-white mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-10 h-10 bg-[#006747] rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-xl">G</span>
              </div>
              <span className="text-xl font-bold">Golf Handicap Pro</span>
            </div>
            <p className="text-gray-400 text-sm">
              Professional USGA-aligned handicap calculators for golfers at all levels. Find your handicap without immediate GHIN costs.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/usga-calculator" className="text-gray-400 hover:text-white transition-colors text-sm">
                  USGA Course Calculator
                </Link>
              </li>
              <li>
                <Link to="/scramble-tools" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Scramble/Tournament Tools
                </Link>
              </li>
              <li>
                <Link to="/formulas" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Handicap Formulas
                </Link>
              </li>
            </ul>
          </div>

          {/* Glossary */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Glossary</h3>
            <ul className="space-y-2">
              {glossaryTerms.map((item) => (
                <li key={item.term}>
                  <Link
                    to={item.path}
                    className="text-gray-400 hover:text-white transition-colors text-sm"
                  >
                    {item.term}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400 text-sm">
          <p>© {new Date().getFullYear()} Golf Handicap Pro. All rights reserved.</p>
          <p className="mt-2">
            Unofficial tracking tool. For official handicaps, visit{" "}
            <a
              href="https://www.ghin.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#22C55E] hover:underline"
            >
              GHIN.com
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
